import { GridHelperService } from '../../../services/grid-helper-service';
import { getRowSelectionsForKeyPress } from '../display-grid-keyboard-actions';
import { getSafeRowIndex } from './safe-row-index';

export const getAdjustedDisplayInformationFromKeypress = (keypress, selected, data, currentlySelectedId, disableMultiSelect) => {
  const count = selected.size;
  const noUpdates = {
    updatedSelected: [],
    updatedCurrentlySelectedId: undefined,
  };

  if (count === 0) {
    return noUpdates;
  }

  const dataIds = data.map((datum) => GridHelperService.getPrimaryRow(datum).id);
  const lastSelectedIndex = dataIds.indexOf(currentlySelectedId);
  const arrowedToIndex = getSafeRowIndex(lastSelectedIndex, keypress.key, data);
  const arrowedToData = GridHelperService.getPrimaryRow(data[arrowedToIndex]);

  if ((keypress.shiftKey || count > 1) && !disableMultiSelect) {
    const selectedRows = dataIds
      .filter((id) => selected.has(id))
      .map((id) => ({
        id,
        selected: selected.has(id),
      }));
    const idsToSelect = getRowSelectionsForKeyPress(arrowedToIndex, keypress.key, dataIds, selectedRows, keypress.shiftKey);

    return {
      updatedSelected: idsToSelect,
      updatedCurrentlySelectedId: idsToSelect.length === 1 ? idsToSelect[0] : arrowedToData.id,
    };
  }

  // this does not deselect top and bottom rows
  if (arrowedToIndex !== lastSelectedIndex) {
    return {
      updatedSelected: [arrowedToData.id],
      updatedCurrentlySelectedId: arrowedToData.id,
    };
  }
  return noUpdates;
};
